<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
        doctorId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("patientsProcedures/getDetails",         { id: this.itemId, doctorId: this.doctorId });

    },
    computed: {
        patient() {
            return this.$store.state.patientsProcedures.patient;
        }
    },
};
</script>